import CloseIcon from "../icons/CloseIcon";

const VideoModal = ({ Context }) => {
  return (
    <div className="text-center bg-white p-3 sm:p-5 rounded-md w-11/12 mx-auto sm:w-[640px] text-2xl">
      <div className="flex items-center justify-between">
        <h2 className="text-[16px] font-bold sm:text-lg capitalize">
          {Context?.state.videoPayload.title}
        </h2>
        <button
          onClick={() =>
            Context?.dispatch({ type: "videoModal", payload: undefined })
          }
        >
          <CloseIcon className="size-3" />
        </button>
      </div>
      <div className="my-2 sm:my-3">
        <iframe
          width="560"
          height="315"
          src={`https://www.youtube.com/embed/${extractYouTubeID(
            Context?.state.videoPayload.videoUrl
          )}`}
          title="YouTube video player"
          frameborder="0"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
          referrerpolicy="strict-origin-when-cross-origin"
          allowfullscreen
          className="w-full h-[50vh]"
        />
      </div>
    </div>
  );
};

export default VideoModal;

function extractYouTubeID(url) {
  const pattern =
    /(?:https?:\/\/)?(?:www\.)?(?:youtube\.com\/(?:[^\/\n\s]+\/\S+\/|(?:v|e(?:mbed)?)\/|\S*?[?&]v=)|youtu\.be\/)([a-zA-Z0-9_-]{11})/;
  const match = url.match(pattern);
  return match ? match[1] : null;
}
